import {Component, forwardRef} from '@angular/core';
import {DictionariesService} from "../../../service";
import {NG_VALUE_ACCESSOR} from "@angular/forms";
import {ViewDictionaryBase} from "../view-dictionary-base";
import {PageOkato1} from "../../../../../../api/build";

@Component({
  selector: 'app-dict-qref-okato1',
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => QrefOkato1ViewComponent),
    multi: true
  }],
  template: `
    <div class="mb-3 col-6 pl-0 pr-0">
      <label class="form-label">{{title}}
        <app-rq *ngIf="isFieldReq(formControl)" [isReadOnly]="isDisabled"></app-rq>
      </label>
      <app-custom-select *ngIf="dictionary | async as dict; else loading"
                         code="ter"
                         name="name"
                         [items]="dict"
                         [returnOnlyId]="true"
                         [formControl]="formControl"
                         [fieldsFromSearch]="['ter', 'name']"
                         [isInvalid]="submitted && formControl.errors">
        <ng-template let-item #labelTemplate>
          <b> {{ item.ter }} </b>
          {{ item.name }}
        </ng-template>
        <ng-template let-item let-search="search" #optionTemplate>
          <div style="white-space: normal">
            <b> {{ item.ter }} </b>
            {{ item.name }}
          </div>
        </ng-template>
      </app-custom-select>
      <ng-template #loading>
        ...загрузка
      </ng-template>
      <app-valid [logic]="formControl" [submitted]="submitted"></app-valid>
    </div>
  `
})
export class QrefOkato1ViewComponent extends ViewDictionaryBase<PageOkato1> {
  getDictionary = this.dictSrv.getQrefOkato1List();
  constructor(private dictSrv: DictionariesService) {
    super();
  }
}
